<template>
<div style="margin-bottom:3rem">

  <!-- DIALO  WITH OPTIONS  -->
  <v-dialog width="1000" v-model="show">
    <v-btn block color="primary" slot="activator">
      {{ $t('related.new_group_type') }}
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('related.new_group_type') }}
      </v-card-title>
      <v-container>
        <v-form ref="form" v-model="valid" v-on:submit="save">
          <v-flex xs8>
            <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.name')}`" required></v-text-field>
          </v-flex>
          <v-select v-model="relatedSchema" :items="relatedSchemas" :label="`${$t('related.related_schema')}`"
                    :rules="schemaRules" item-text="name" item-value="id"
                    required @change="update({relatedId: $event})">
          </v-select>
          <v-btn type="submit">
            {{ $t('archive.filter.save') }}
          </v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- END DIALOG -->

</div>
</template>
<script>
import http from '@/plugins/http'

export default {
  components: {},
  data() {
    return {
      name: "",
      valid: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 1) || this.$t('validator.wrong_length'),
      ],
      schemaRules: [v => !!v || this.$t('validator.blank')],
      relatedSchema: null,
      show: false
    }
  },
  computed: {
    relatedSchemas() {
      return this.$store.state.relatedSchemas
    }
  },
  created() {
    this.loadRelatedSchemas()
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.valid) {
        http.post('related/group/type', this.getPayload())
          .then((data) => {
            this.$emit("created", data.data)
            this.$refs.form.reset()
            this.show = false;
            this.showMessage(this.$t('related.created'), "success")
          })
          .catch(() => this.showMessage(this.$t('related.cannot_create'), "danger"))
      }
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      payload['related_schema_id'] = this.relatedSchema

      return payload;
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    },
    loadRelatedSchemas() {
      if (this.relatedSchemas.length == 0)
        return this.$store.dispatch('loadRelatedSchemas')
    }
  },
}
</script>

<style>

</style>
